import { useTranslation } from 'react-i18next';

import styles from './StatusChip.module.scss';

type StatusColor = 'default' | 'success' | 'info' | 'warning' | 'error';

const statusColorMap: Record<string, StatusColor> = {
  draft: 'default',
  active: 'success',
  completed: 'info',
  cancelled: 'error',
  not_started: 'default',
  in_progress: 'warning',
  blocked: 'error',
  pending: 'warning',
  preparing_shipment: 'info',
  shipped: 'info',
  delivered: 'success',
  submitted_by_patient: 'warning',
  confirmed: 'success',
  rejected: 'error',
  verified: 'success',
};

type StatusChipProps = {
  readonly status: string;
  readonly size?: 'small' | 'medium';
};

export function StatusChip({ status, size = 'small' }: StatusChipProps) {
  const { t } = useTranslation();
  const color = statusColorMap[status] ?? 'default';

  return (
    <span className={`${styles.chip} ${styles[color]} ${size === 'small' ? styles.sm : ''}`}>
      {t(`status.${status}`, status)}
    </span>
  );
}
